import React from "react";
import axios from 'axios';


import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import tokenErrorHandler from "../tokenErrorHandler";

import './SenderDetails.css';
import './SendersList.css';
import './SenderPhotoUpload.css';
import FooterComponet from "../FooterComponent/FooterComponet";

import AddedBeneficiary from "../BeneficiaryComponent/AddedBeneficiary";
import { store } from "../../redux/store";
import { setBankDetails, setCustomerLimit } from './../../redux/misc-data/misc-data.action';
import Avatar from 'react-avatar';
import moment from "moment";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";


const httpClient = axios.create();


class Sender extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: ''
		}
	}





	componentDidMount() {
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id
			,
			'role': this.props.clientRole
		}


		httpClient.get('/api/v1/dmt/order/limit/customer/' +
			this.props.selectSender.customer.id,
			{ headers }
		).then((response) => {
			store.dispatch(setCustomerLimit(response.data));


		}).catch(error => {
			store.dispatch(setCustomerLimit('error'));
		
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else {

			}

		});

	}
	componentWillUnmount() {
	}



	render() {
		console.log(this.props.selectSender)
		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">
					{/* <LeftMenu/> */}

					<div class="right-side">
						<div class="container-fluid">

							{/* <Header/> */}

							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Sender Details</h3>
												<div class="headbtn">
													<Link to='/dmt'>
														<button class="dbbtn" type="button">Back</button>
													</Link>

												</div>
											</div>

											<div class="senderdtl">
												<div class="senderdtlcard">
													<div class="row">
														<div class="col-12 col-sm-6 col-md-4">
															<div class="sender-profile">
																<Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" />
																<h4>{this.props.selectSender.customer.name}</h4>
																<p>{this.props.selectSender.customer.mobile}</p>
															</div>
														</div>

														<div class="col-12 col-md-3">
															<div class="sender-profile">
																<h5>{this.props.selectSender.customer.kyc.type == 'AADHAAR_CARD' ? 'Aadhaar Card' :
																	this.props.selectSender.customer.kyc.type == 'BILL_ADDRESS_PRROF' ? 'Voter Card' :
																		this.props.selectSender.customer.kyc.type.split('_').join('')}</h5>
																<p>{this.props.selectSender.customer.kyc.id}</p>
															</div>
														</div>

														<div class="col-6 col-md-2">
															<div class="sender-profile">
																<h5>Available Limit</h5>
																<p> {(this.props.customerLimit != '' &&
																	this.props.customerLimit != 'error') ?
																	'₹' + parseFloat(this.props.customerLimit).toFixed(2) :
																	this.props.customerLimit
																}</p>
															</div>
														</div>

														<div class="col-6 col-md-3">
															<div class="sender-profile rtxt">
																<h6>Added Date</h6>
																<p>{moment(this.props.selectSender.customer.updatedOn).format('DD-MM-YYYY hh:mm:ss')}</p>
															</div>
														</div>
													</div>
												</div>



												<AddedBeneficiary />


											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectSender, agentInfo, token, clientRole,
			customerLimit, selecetdBenefisciaries, callBackUrl } }
) => ({
	errorMessage, loginErrorMessage, phone, selectSender, agentInfo, token, clientRole,
	customerLimit, selecetdBenefisciaries, callBackUrl
});

export default connect(mapStateToProps, null)(Sender);
